// JSON encoding keeps partnership identifiers unambiguous even when player
// names contain punctuation such as the old "|" delimiter.
export const partnershipKey = (pair = []) => JSON.stringify(
  [...pair].map((player) => String(player)).sort()
);
